import { Link } from 'react-router-dom';
import platformImg from '../pics/pexels-cowomen-1058097-2041627.jpg';
import pipelineImg from '../pics/pexels-goumbik-577210.jpg';
import analyticsImg from '../pics/pexels-scottwebb-1048049.jpg';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Architect Your Data. Accelerate Your Insights.</h1>
          <p>End-to-end data platform engineering, cloud architecture and BI solutions on Azure</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img src={platformImg} alt="Cloud Data Platform Engineering" className="service-image" />
              <h3>Cloud Data Platform Engineering</h3>
              <p>
                Design, build and migrate modern data platforms on Azure. From Data Warehouse 
                migrations to Lakehouse architectures on Databricks, Fabric and Fabric — we 
                deliver scalable, production-ready solutions with Azure DevOps CI/CD and Bicep 
                Infrastructure as Code.
              </p>
            </div>
            <div className="service-card">
              <img src={pipelineImg} alt="Data Integration and Orchestration" className="service-image" />
              <h3>Data Integration & Orchestration</h3>
              <p>
                Extract, Load and Transform at scale using Azure Data Factory and PySpark. We 
                architect robust data pipelines with lifecycle management across Databricks, 
                Fabric and Fabric, enabling reliable data flows from source to insight.
              </p>
            </div>
            <div className="service-card">
              <img src={analyticsImg} alt="Business Intelligence and Analytics" className="service-image" />
              <h3>Business Intelligence & Analytics</h3>
              <p>
                Power BI development with deep experience in Premium and Embedded capacities. 
                We build enterprise reporting frameworks, manage geo-distributed gateways and 
                embed analytics as a service for internal teams and external clients alike.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Expertise & Skills</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon" role="img" aria-label="Architecture compass and plans">
                📐
              </div>
              <h3>Data Architecture</h3>
              <p>End-to-end data strategy, design and cloud architecture on Azure</p>
            </div>
            <div className="feature">
              <div className="feature-icon">⚙️</div>
              <h3>Azure Cloud DataOps</h3>
              <p>DevOps, Bicep IaC, YAML pipelines and automated deployments</p>
            </div>
            <Link to="/lakehouses" className="feature feature-link">
              <div className="feature-icon" role="img" aria-label="Databricks logo">
                <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true" focusable="false">
                  <g fill="none" stroke="#ff3621" strokeWidth="2" strokeLinejoin="round">
                    <path d="M16 2 29 8.5 16 15 3 8.5 16 2Z" />
                    <path d="m3 13.5 13 6.5 13-6.5M3 18.5 16 25l13-6.5M3 23.5 16 30l13-6.5" />
                  </g>
                </svg>
              </div>
              <h3>Databricks & Fabric</h3>
              <p>PySpark, Lakehouse patterns, Data Factory and data lifecycle management</p>
              <span className="feature-link-cta">See our 90-day lakehouse offer →</span>
            </Link>
            <div className="feature">
              <div className="feature-icon">📈</div>
              <h3>Power BI & Power Platform</h3>
              <p>Premium workspaces, embedded analytics, RBAC and Azure AD integration</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🤝</div>
              <h3>Consulting & Pre-Sales Support</h3>
              <p>Customer engagement, solution design and technical pre-sales support</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
